<!-- src/components/Users/UsersMain.vue -->
<template>
    <div>
        <b-tabs lazy card v-model="activeTab">
            <b-tab title="LIST USERS" title-link-class="tab-link">
                <ListUsers ref="listUsers" />
            </b-tab>
            <b-tab title="HIERARCHY VIEW" title-link-class="tab-link">
                <UserHierarchy 
                    ref="userHierarchy"
                    @edit-user="handleEditUser" 
                    @add-user="handleAddUser" 
                />
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
    import ListUsers from '@/components/Users/ListUsers'
    import UserHierarchy from '@/components/Users/UserHierarchy'

    export default {
        name: "UsersMain",
        components: { ListUsers, UserHierarchy },
        data: function() {
            return {
                packet: {},
                activeTab: 0,
                pendingEditUser: null
            }
        },
        methods: {
            handleEditUser: function(user) {
                console.log('📝 Editing user:', user.fullname || user.username);
                console.log('📝 User ID:', user.id);
                
                // Store the user to edit
                this.pendingEditUser = user;
                
                // Switch to list users tab (index 0)
                this.activeTab = 0;
                
                // Wait for tab to render then trigger edit
                setTimeout(function() {
                    this.openUserEdit();
                }.bind(this), 400);
            },

            handleAddUser: function() {
                console.log('➕ Adding new user');
                this.pendingEditUser = null;
                this.activeTab = 0;
                
                setTimeout(function() {
                    this.openUserAdd();
                }.bind(this), 400);
            },

            openUserEdit: function() {
                console.log('🔍 Opening edit for user:', this.pendingEditUser);
                
                if (this.$refs.listUsers && this.pendingEditUser) {
                    try {
                        // Call the show_user method from ListUsers
                        this.$refs.listUsers.show_user({ id: this.pendingEditUser.id });
                        this.pendingEditUser = null;
                        console.log('✅ Edit modal opened successfully');
                    } catch (error) {
                        console.error('❌ Error opening edit user:', error);
                        this.$bvToast.toast(
                            'Error opening user edit. Please try again from the list view.',
                            { title: "Error", autoHideDelay: 3000, variant: "warning" }
                        );
                    }
                } else {
                    console.warn('⚠️ ListUsers ref not available, retrying...');
                    // Retry after a delay
                    setTimeout(function() {
                        this.openUserEdit();
                    }.bind(this), 500);
                }
            },

            openUserAdd: function() {
                console.log('🔍 Opening add user');
                
                if (this.$refs.listUsers) {
                    try {
                        // Call the add method from ListUsers
                        this.$refs.listUsers.add({ preventDefault: function() {} });
                        console.log('✅ Add modal opened successfully');
                    } catch (error) {
                        console.error('❌ Error opening add user:', error);
                        this.$bvToast.toast(
                            'Error opening add user form. Please try again from the list view.',
                            { title: "Error", autoHideDelay: 3000, variant: "warning" }
                        );
                    }
                } else {
                    console.warn('⚠️ ListUsers ref not available, retrying...');
                    setTimeout(function() {
                        this.openUserAdd();
                    }.bind(this), 500);
                }
            }
        },
        created: function() {
            this.packet = JSON.parse(localStorage.getItem('packet'));
            this.packet.userDetails = JSON.parse(localStorage.getItem('userDetails'));

            if (this.packet.userDetails.userrole !== 'admin') {
                localStorage.clear();
                this.$router.push("/");
            }
        },
        mounted: function() {
            console.log('✅ UsersMain mounted, ListUsers ref:', !!this.$refs.listUsers);
        }
    }
</script>

<style scoped>
.tab-link {
    font-weight: 600;
    color: #4a5568;
    padding: 8px 16px;
}

.tab-link.active {
    color: #2d3748;
    border-bottom: 2px solid #2d3748;
}
</style>


// WEBPACK FOOTER //
// src/components/Users/UsersMain.vue